<script>
    import { onMount, createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();
    let carrfilt = [];
    let carreras = [];
    let autofocus = true;
    let buscar = "";
    let displayModal = "none";
    let egreso = {
        anio: "",
        nom_car: "",
        cod_uni: "",
        cod_car: "",
    };

    let displayMensaje = "none";
    let mensaje = "";

    export let display = "none";

    $: {
        carrfilt = [];
        carreras.map((c) => {
            if (c.nom_car.toUpperCase().includes(buscar.toUpperCase()))
                carrfilt.push(c);
        });
        carrfilt = [...carrfilt];
    }

    onMount(async () => {
        const body = new FormData();
        body.append("accion", "seleccionar");

        const rst = await fetch("./api/carreras.php", {
            method: "POST",
            body,
        });

        if (rst.ok) {
            const json = await rst.json();
            if (json.error) {
                alert("Lo sentimos, se produjo un error intenta más tarde.");
            } else {
                carreras = [...json.datos];
            }
        }
    });

    function elige_carrera(c) {
        egreso.cod_uni = c.cod_uni;
        egreso.cod_car = c.cod_car;
        egreso.nom_car = c.nom_car;
        egreso.anio = "";
        displayModal = "block";
    }

    function confirmar() {
        let anio = parseInt(egreso.anio);
        if (isNaN(anio)) {
            aviso.mostrar("Deber ingresar una año mayor o igual 1950");
            return;
        }
        if (anio < 1950) {
            aviso.mostrar("Deber ingresar una año mayor o igual 1950");
            return;
        }

        egreso.anio=anio;
    
        displayModal = "none";

        dispatch('agregar',{...egreso});
    }
</script>

<div class="w3-modal" style="display: {display};">
    <div class="w3-content w3-round w3-white w3-animatetop">
        <div class="w3-padding">
            <div class="w3-display-container" style="height:45px">
                <div class="w3-display-left">
                    <h3>Seleccionar Carreras</h3>
                </div>
                <button
                    class="w3-btn w3-display-right w3-red"
                    on:click={() => dispatch("cerrar")}>X</button
                >
            </div>
            <div class="w3-section">
                <input
                    type="text"
                    class="w3-input w3-light-grey w3-round"
                    placeholder="Buscar..."
                    {autofocus}
                    bind:value={buscar}
                />
            </div>
            <div class="w3-section">
                <div class="w3-responsive">
                    <table class="w3-table-all w3-hoverable">
                        <thead>
                            <tr>
                                <th>Carrera</th>
                            </tr>
                        </thead>
                        <tbody>
                            {#each carrfilt as c}
                                <tr
                                    class="fila"
                                    on:click={() => elige_carrera(c)}
                                >
                                    <td>{c.nom_car}</td>
                                </tr>
                            {/each}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="w3-modal" style="display:{displayModal}">
    <div class="w3-modal-content w3-white w3-animatetop">
        <div class="w3-padding">
            <div class="w3-display-container" style="height:45px">
                <div class="w3-display-left">
                    <h3>Carrera elegida</h3>
                </div>
                <button
                    class="w3-btn w3-display-right w3-red"
                    on:click={() => (displayModal = "none")}>x</button
                >
            </div>
            <div class="w3-section">
                <label>Carrera elegida:</label>
                <input
                    type="text"
                    readonly
                    class="w3-input w3-light-grey"
                    bind:value={egreso.nom_car}
                />
            </div>
            <div class="w3-section">
                <label>Año de egreso:</label>
                <input
                    type="text"
                    class="w3-input w3-light-grey"
                    on:focus={() => (displayMensaje = "none")}
                    bind:value={egreso.anio}
                />
            </div>
            <div class="w3-section" style="display:{displayMensaje}">
                <div class="w3-padding w3-round w3-orange">{mensaje}</div>
            </div>
            <div class="w3-section">
                <button class="w3-btn w3-blue w3-round" on:click={confirmar}
                    >Confimar</button
                >
            </div>
        </div>
    </div>
</div>
